import React, { useState } from 'react';
import { Modal, Button, Form, Alert } from 'react-bootstrap';
import { patchLead } from '../api';

const LeadEditModal = ({ show, handleClose, lead, onUpdate }) => {
    const [formData, setFormData] = useState({
        name: lead?.name || '',
        zipCode: lead?.zipCode || ''
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            const updateData = {};
            if (formData.name.trim() !== (lead?.name || '')) {
                updateData.name = formData.name.trim();
            }
            if (formData.zipCode.trim() !== (lead?.zipCode || '')) {
                updateData.zipCode = formData.zipCode.trim();
            }

            if (Object.keys(updateData).length > 0) {
                await patchLead(lead.id, updateData);
                onUpdate();
            }
            handleClose();
        } catch (error) {
            setError('Error al actualizar los datos');
            console.error('Error updating lead:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Completar Información del Lead</Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleSubmit}>
                <Modal.Body>
                    {error && <Alert variant="danger">{error}</Alert>}
                    
                    {(!lead?.name || lead.name.trim() === '') && (
                        <Form.Group className="mb-3">
                            <Form.Label>Nombre</Form.Label>
                            <Form.Control
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                maxLength={50}
                                placeholder="Ingrese el nombre del lead"
                            />
                        </Form.Group>
                    )}

                    {(!lead?.zipCode || lead.zipCode.trim() === '') && (
                        <Form.Group className="mb-3">
                            <Form.Label>Código Postal</Form.Label>
                            <Form.Control
                                type="text"
                                name="zipCode"
                                value={formData.zipCode}
                                onChange={handleChange}
                                maxLength={10}
                                placeholder="Ingrese el código postal"
                            />
                        </Form.Group>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose} disabled={loading}>
                        Cancelar
                    </Button>
                    <Button variant="primary" type="submit" disabled={loading}>
                        {loading ? 'Guardando...' : 'Guardar'}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default LeadEditModal;